<template>
  <div class="flex flex-1 flex-col gap-2">
    <h3 class="text-heading-2 pb-2 pl-2">{{ props.listTitle }}</h3>
    <div class="flex flex-col pr-4">
      <RfButtonNew
        v-for="device in props.items"
        :key="device[props.valueKey]"
        type="round"
        :disabled="props.disabled"
        class="justify-start"
        :class="{
          'text-beige-90 bg-beige-1 [&_.rf-icon]:stroke-beige-90 [&_.rf-icon]:fill-beige-90 disabled':
            model && model[props.valueKey] === device[props.valueKey],
        }"
        :title="titleAccessor(device)"
        @click="() => (model = device)"
      >
        <component
          :is="device[props.iconKey]"
          v-if="device[props.iconKey]"
          class="h-6 w-6 shrink-0"
        />
        {{ titleAccessor(device) }}
      </RfButtonNew>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import RfButtonNew from "@/components/buttons/RfButtonNew.vue";

const model = defineModel({
  type: Object,
  default: null,
});
const props = defineProps({
  items: { type: [Array, Object], required: true },
  listTitle: { type: String, required: true },
  titleKey: { type: [String, Function], required: true },
  iconKey: { type: String, default: "" },
  valueKey: { type: String, default: "value" },
  disabled: { type: [String, Boolean], default: false },
});

const titleAccessor = computed(() =>
  typeof props.titleKey === "function" ? props.titleKey : item => item[props.titleKey],
);
</script>
